module.exports = __webpack_public_path__ + "img/guide-status-videos.8cb6d155.webp";